<div class="card" [ngClass]="{'confidential-active': isConfidentialMode}">
    <div class="card-header">
        <div class="inner-header flex-column">
            <h3 [ngClass]="{'text-white': isConfidentialMode}">
                Check text for AI
                <a href="#disclaimerModal" data-toggle="modal" data-target="#disclaimerModal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9 0.937499C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625C4.5525 17.0625 0.9375 13.4475 0.937501 9C0.937501 4.5525 4.5525 0.937499 9 0.937499ZM9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375Z" fill="#4f4f4f"/>
                        <path d="M9 7.6875C9.3075 7.6875 9.5625 7.9425 9.5625 8.25L9.5625 12C9.5625 12.3075 9.3075 12.5625 9 12.5625C8.6925 12.5625 8.4375 12.3075 8.4375 12L8.4375 8.25C8.4375 7.9425 8.6925 7.6875 9 7.6875Z" fill="#4f4f4f"/>
                        <path d="M9 5.24984C9.0975 5.24984 9.195 5.27234 9.285 5.30984C9.375 5.34734 9.4575 5.39984 9.5325 5.46734C9.6 5.54234 9.6525 5.61734 9.69 5.71484C9.7275 5.80484 9.75 5.90234 9.75 5.99984C9.75 6.09734 9.7275 6.19484 9.69 6.28484C9.6525 6.37484 9.6 6.45734 9.5325 6.53234C9.4575 6.59984 9.375 6.65234 9.285 6.68984C9.105 6.76484 8.895 6.76484 8.715 6.68984C8.625 6.65234 8.5425 6.59984 8.4675 6.53234C8.4 6.45734 8.3475 6.37484 8.31 6.28484C8.2725 6.19484 8.25 6.09734 8.25 5.99984C8.25 5.90234 8.2725 5.80484 8.31 5.71484C8.3475 5.61734 8.4 5.54234 8.4675 5.46734C8.5425 5.39984 8.625 5.34734 8.715 5.30984C8.805 5.27234 8.9025 5.24984 9 5.24984Z" fill="#4f4f4f"/>
                    </svg>
                </a>
            </h3>
            <div class="sessionsLeftInfo">
                <ul>
                    <li *ngIf="usersCurrentAvailableSessionCount > -1">
                        <span [ngClass]="usersCurrentAvailableSessionCount === 0 ? 'red-txt': ''">{{usersCurrentAvailableSessionCount}}/10 sessions remaining today</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="cdp-switch">
            <label class="confidential-switch">
                <span class="confidential-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z"></path>
                        <path d="M9 12l2 2 4-4"></path>
                    </svg>
                    Confidential mode
                </span>
            
                <input type="checkbox" class="switch-input" [checked]="isConfidentialMode" (change)="isConfidentialMode = !isConfidentialMode" />
            
                <span class="switch-track">
                    <span class="switch-thumb"></span>
                </span>
            </label>
        </div>
    </div>
    <div class="pc-note">
        <!-- <p>Working with unpublished or sensitive text? Switch on <span>Confidential mode</span>.</p> -->
        <div class="confidential-plan-info">
            <span class="plan-title">
                Confidential Data Plan
            </span>
        
            <span class="plan-feature">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"></path>
                </svg>
                Real-time data deletion
            </span>
        
            <span class="plan-feature">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="9"></circle>
                    <path d="M5.6 5.6l12.8 12.8"></path>
                </svg>
                No AI training on your text
            </span>
        
            <span class="plan-feature">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z"></path>
                    <path d="M9 12l2 2 4-4"></path>
                </svg>
                HIPAA & GDPR compliant
            </span>
        </div>
    </div>
    <div class="card-body">
        <div class="left-side">
            <div class="form-group" [ngClass]="[showWordLimitErr && wordLimitErrMsg.includes('500') ? 'show-max-overlay' : '']" *ngIf="!aiContentScore && !humanContentScore">
                <div class="editor-wrapper scollBarAI" [ngClass]="[showErrorModal ? 'hide-all-content' : showLoadingState ? 'blur-content' : aiContentScore > 0 ? 'error-txt' : '']">
                    <span *ngIf="inputWordCount" class="cross-icon-times" (click)="clearEditors();"></span>
                    <div #inputEditor [contentEditable]="!showLoadingState && aiContentScore === 0 && humanContentScore === 0 && !showErrorModal" id="inputEditor"
                        placeholder="Type or paste your text in English (Minimum 100 words)" class="editor" (input)="onInputEditorChange(inputEditor.innerText)"
                        contenteditable="true"
                        data-gramm="false"
                        data-gramm_editor="false"
                        data-enable-grammarly="false"    
                    >
                    </div>
                    <div class="error-container" *ngIf="showErrorModal">
                        <div class="error-txt-container">
                            <span class="danger-icon"></span>
                            <span class="error-txt">An error occurred, please try again</span>
                        </div>
                    </div>
                </div>
                <div class="limit-snackbar" [ngClass]="wordLimitErrHeading.includes('100') ? 'min-limit-snackbar' : 'max-limit-snackbar'" *ngIf="showWordLimitErr">
                    <h3>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.4645 14.3459L13.248 4.95619C12.5471 3.69282 11.5771 3 10.5094 3C9.44161 3 8.47166 3.69282 7.77069 4.95619L2.55419 14.3459C1.89397 15.5441 1.82062 16.6933 2.35042 17.5981C2.88022 18.5028 3.92352 19 5.29285 19H15.7259C17.0952 19 18.1385 18.5028 18.6683 17.5981C19.1981 16.6933 19.1247 15.5359 18.4645 14.3459ZM9.89805 8.70555C9.89805 8.37137 10.1752 8.09424 10.5094 8.09424C10.8435 8.09424 11.1207 8.37137 11.1207 8.70555V12.7809C11.1207 13.1151 10.8435 13.3923 10.5094 13.3923C10.1752 13.3923 9.89805 13.1151 9.89805 12.7809V8.70555ZM11.0881 15.8049C11.0473 15.8375 11.0066 15.8701 10.9658 15.9027C10.9169 15.9353 10.868 15.9598 10.8191 15.9761C10.7702 16.0005 10.7213 16.0168 10.6642 16.025C10.6153 16.0331 10.5583 16.0413 10.5094 16.0413C10.4605 16.0413 10.4034 16.0331 10.3463 16.025C10.2974 16.0168 10.2485 16.0005 10.1996 15.9761C10.1507 15.9598 10.1018 15.9353 10.0529 15.9027C10.0122 15.8701 9.97141 15.8375 9.93065 15.8049C9.78394 15.65 9.69428 15.4381 9.69428 15.2262C9.69428 15.0143 9.78394 14.8023 9.93065 14.6475C9.97141 14.6149 10.0122 14.5823 10.0529 14.5497C10.1018 14.5171 10.1507 14.4926 10.1996 14.4763C10.2485 14.4519 10.2974 14.4356 10.3463 14.4274C10.4523 14.403 10.5664 14.403 10.6642 14.4274C10.7213 14.4356 10.7702 14.4519 10.8191 14.4763C10.868 14.4926 10.9169 14.5171 10.9658 14.5497C11.0066 14.5823 11.0473 14.6149 11.0881 14.6475C11.2348 14.8023 11.3244 15.0143 11.3244 15.2262C11.3244 15.4381 11.2348 15.65 11.0881 15.8049Z" fill="#FFBD4A"/>
                        </svg>
                        {{wordLimitErrHeading}}
                    </h3>
                    <p [innerHTML]="wordLimitErrMsg" *ngIf="wordLimitErrMsg"></p>
                    <span class="limit-modal-close" aria-label="close" (click)="hideLimitError()">
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.4082 6.66472C17.7614 6.31148 17.7614 5.73877 17.4082 5.38553C17.0549 5.0323 16.4822 5.0323 16.129 5.38553L11.3414 10.1731L6.55388 5.38553C6.20064 5.0323 5.62793 5.0323 5.27469 5.38553C4.92146 5.73877 4.92146 6.31148 5.27469 6.66472L10.0622 11.4523L5.27469 16.2398C4.92146 16.593 4.92146 17.1658 5.27469 17.519C5.62793 17.8722 6.20064 17.8722 6.55388 17.519L11.3414 12.7315L16.129 17.519C16.4822 17.8722 17.0549 17.8722 17.4082 17.519C17.7614 17.1658 17.7614 16.593 17.4082 16.2398L12.6206 11.4523L17.4082 6.66472Z" fill="#414E62"/>
                        </svg>
                    </span>
                </div>
            </div>


            <div class="ai-score-card" *ngIf="aiContentScore || humanContentScore">

                <div class="ai-score-card__header">
                <span class="ai-score-card__score">
                    {{ Math.floor(aiContentScore) }}
                </span>

              
                <div class="ai-score-card__info">
                    <span class="ai-score-card__label">AI score</span>
              
                    <span class="ai-score-card__status">
                        <span
                            class="ai-score-card__dot"
                            [ngClass]="{
                                'confident-human': aiContentScore <= 19,
                                'leaning-human': aiContentScore >= 20 && aiContentScore <= 39,
                                'inconclusive': aiContentScore >= 40 && aiContentScore <= 59,
                                'leaning-ai': aiContentScore >= 60 && aiContentScore <= 79,
                                'confident-ai': aiContentScore >= 80
                            }">
                        </span>
                        <span>{{ getScoreLabel(aiContentScore) }}</span>
                    </span>
                  </div>
                </div>
              
                <div class="ai-score-card__progress">
              
                    <div class="ai-score-card__bar">
                        <span
                            class="ai-score-card__indicator"
                            [style.left]="'calc(' + aiContentScore + '% - 3px)'">
                        </span>
                    </div>
              
                  <div class="ai-score-card__legend">
                    <span>Human</span>
                    <span>Uncertain</span>
                    <span>AI</span>
                  </div>
              
                </div>
              
                <div class="ai-score-card__cta">
                  <span>
                    Unlock the full report: score distribution, paragraph breakdown and PDF.
                  </span>
              
                  <a [routerLink]="['/pricing']">
                    See plans →
                  </a>
                </div>
              
                <button class="ai-score-card__reset" (click)="checkAnotherText()">
                  Check another text
                </button>
              
            </div>
            
        </div>
    </div>
    <div class="example-chips" *ngIf="!aiContentScore && !humanContentScore">
        <span class="example-label">Try an example:</span>
      
        <button 
          class="chip"
          [class.active]="activeExample === 'ai'"
          (click)="loadExample('ai')">
          AI-written
        </button>
      
        <button 
          class="chip"
          [class.active]="activeExample === 'humanized'"
          (click)="loadExample('humanized')">
          Humanized AI
        </button>
      
        <button 
          class="chip"
          [class.active]="activeExample === 'human'"
          (click)="loadExample('human')">
          Human-written
        </button>
    </div>
    <div class="card-footer" [ngClass]="inputWordCount > 0 ? '' : 'hide-box-shadow'">
        <div class="word-count-outer" *ngIf="!showLoadingState && !showErrorModal">
            <div class="counter">
                <span class="count" [ngClass]="inputWordCount > 500 ? 'red-txt': inputWordCount > 0 ? 'black-txt' : ''">{{ inputWordCount }}/500 words</span>
            </div>
        </div>
        <div class="button-wrap">
            <div class="btn-group">
                <a href="https://cloud.trinka.ai/signup?_rg=GB" class="outline-btn" *ngIf="!isConfidentialMode && !aiContentScore && !humanContentScore" target="_blank">
                    Upload File
                </a>
                <button *ngIf="!aiContentScore && !humanContentScore" (click)="sendTextForAIDetection()" [ngClass]="[showLoadingState ? 'loaderStateBtn' : '']" [disabled]="inputWordCount === 0 || isSubmitBtnDisabled || showLoadingState">
                    <span *ngIf="showLoadingState" class="animated-loader"></span>
                    <span>
                        {{ 
                            showLoadingState 
                            ? 'Checking' 
                            : showErrorModal 
                            ? 'Reload' 
                            : isConfidentialMode 
                            ? 'Detect AI Securely' 
                            : 'Detect AI'
                        }}
                    </span>
                </button>
                <!-- <a *ngIf="isConfidentialMode && !aiContentScore && !humanContentScore" [routerLink]="['/pricing']" class="outline-btn">Get Now - 40% 0ff</a> -->
            </div>
            <!-- <div class="ai-generated-txt-btn" *ngIf="aiContentScore">
                AI Generated Text ({{aiContentScore.toFixed(2)}}%)
            </div>
            <div class="human-generated-txt-btn" *ngIf="humanContentScore">
                Human Generated Text ({{humanContentScore.toFixed(2)}}%)
            </div> -->
            <span class="like-dislike-container" *ngIf="humanContentScore || aiContentScore">
                <span class="feedback-like-icon" (click)="openFeedbackModal(true)"></span>
                <span class="feedback-dislike-icon" (click)="openFeedbackModal(false)"></span>
            </span>
        </div>
    </div>
    <!-- <div class="ftContent" *ngIf="humanContentScore">
        <div class="human-generated-txt-content">
            <h6>Score explanation:</h6>
            <span class="information-icon-green">
                <span class="information-icon-content-outer">
                    <span class="information-icon-content-score">
                        The score reflects our model's confidence in predicting that the content scanned was produced by any of the LLMs such as ChatGPT/GPT-X. The score indicates that {{humanContentScore.toFixed(2)}}% of your text is Human generated. This score was computed through sentence-level analysis, where we discerned AI-generated content within each sentence.
                    </span>
                    <span class="information-icon-content-constant">
                        Our system is tailored to excel in predicting AI-generated content in English. It's worth noting that accuracy levels for other languages may not be on par with this proficiency.                                      
                    </span>
                </span>
            </span>
        </div>
    </div>
    <div class="ftContent" *ngIf="aiContentScore">
        <div class="human-generated-txt-content">
            <h6>Score explanation:</h6>
            <span class="information-icon-red">
                <span class="information-icon-content-outer">
                    <span class="information-icon-content-score">
                        The score reflects our model's confidence in predicting that the content scanned was produced by any of the LLMs such as ChatGPT/GPT-X. The score indicates that {{aiContentScore.toFixed(2)}}% of your text is AI generated. This score was computed through sentence-level analysis, where we discerned AI-generated content within each sentence.
                    </span>
                    <span class="information-icon-content-constant">
                        Our system is tailored to excel in predicting AI-generated content in English. It's worth noting that accuracy levels for other languages may not be on par with this proficiency.
                    </span>
                </span>
            </span>
        </div>
    </div>
    <div class="btn-group justify-content-center mb-4" *ngIf="aiContentScore || humanContentScore">
        <a [routerLink]="['/pricing']" class="filled-btn">Upgrade to Download Report</a>
    </div> -->
</div>


<!-- The DisclaimerModal -->
<div class="modal aiContentModal" id="disclaimerModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-radius16">
        <div class="modal-body modalContent">
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M21.825 7.82463C22.2806 7.36902 22.2806 6.63033 21.825 6.17472C21.3694 5.7191 20.6307 5.7191 20.1751 6.17472L14 12.3498L7.825 6.17472C7.36939 5.7191 6.63069 5.7191 6.17508 6.17472C5.71947 6.63033 5.71947 7.36902 6.17508 7.82463L12.3501 13.9997L6.17508 20.1747C5.71947 20.6303 5.71947 21.369 6.17508 21.8246C6.63069 22.2802 7.36939 22.2802 7.825 21.8246L14 15.6496L20.1751 21.8246C20.6307 22.2802 21.3694 22.2802 21.825 21.8246C22.2806 21.369 22.2806 20.6303 21.825 20.1747L15.65 13.9997L21.825 7.82463Z" fill="#414E62"/>
                </svg>
            </button>
            <h4>Disclaimer</h4>
            <p>Our AI-generated content detector is designed to assist in identifying content that may have been produced by an AI generator. However, this evaluation might not always accurately distinguish between human and AI-created content, so it should not be the sole factor in determining the nature of the content. You should thoroughly examine the content and rely on both personal judgment and the organization's policies to make the final decision.</p>
        </div>
      </div>
    </div>
</div>
